/* global axios */
import ApiClient from './ApiClient';

class ActiveGamesAiAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  suggest(conversationId, payload, signal) {
    const { action, ...rest } = payload;
    return axios.post(
      `${this.url}/${conversationId}/active_games_ai`,
      { ...rest, task: action },
      { signal }
    );
  }
}

export default new ActiveGamesAiAPI();
